import * as React from 'react';
import Svg, { Circle, Path, SvgProps } from 'react-native-svg';

const Cart: React.FC<SvgProps & { hasNotification: boolean }> = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={24}
    fill="none"
    viewBox="0 0 27 24"
    {...props}>
    <Path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
    />
    {props?.hasNotification && <Circle cx={23} cy={5} r={4} fill="#F23030" />}
  </Svg>
);

export default Cart;
